document.querySelectorAll('.product__thumb-item a').forEach(thumb => {
    thumb.addEventListener('click', () => {
        document.querySelector('.variant-input .variant__button-label[data-media-id="' + thumb.getAttribute('data-id') + '"]').click()
    });
});

// Start tabs.js
(function() {

  'use strict';

  /**
   * tabs
   *
   * @description The Tabs component.
   * @param {Object} options The options hash
   */
  var tabs = function(options) {

    var el = document.querySelector(options.el);
    var tabNavigationLinks = el.querySelectorAll(options.tabNavigationLinks);
    var tabContentContainers = el.querySelectorAll(options.tabContentContainers);
    var activeIndex = 0;
    var initCalled = false;

    /**
     * init
     *
     * @description Initializes the component by removing the no-js class from
     *   the component, and attaching event listeners to each of the nav items.
     *   Returns nothing.
     */
    var init = function() {
      if (!initCalled) {
        initCalled = true;
        el.classList.remove('no-js');
        
        for (var i = 0; i < tabNavigationLinks.length; i++) {
          var link = tabNavigationLinks[i];
          handleClick(link, i);
        }
      }
    };

    /**
     * handleClick
     *
     * @description Handles click event listeners on each of the links in the
     *   tab navigation. Returns nothing.
     * @param {HTMLElement} link The link to listen for events on
     * @param {Number} index The index of that link
     */
    var handleClick = function(link, index) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        goToTab(index);
      });
    };

    /**
     * goToTab
     *
     * @description Goes to a specific tab based on index. Returns nothing.
     * @param {Number} index The index of the tab to go to
     */
    var goToTab = function(index) {
      if (index !== activeIndex && index >= 0 && index <= tabNavigationLinks.length) {
        tabNavigationLinks[activeIndex].classList.remove('is-active');
        tabNavigationLinks[index].classList.add('is-active');
        tabContentContainers[activeIndex].classList.remove('is-active');
        tabContentContainers[index].classList.add('is-active');
        activeIndex = index;
      }
    };

    /**
     * Returns init and goToTab
     */
    return {
      init: init,
      goToTab: goToTab
    };

  };

  /**
   * Attach to global namespace
   */
  window.tabs = tabs;

})();
// End tabs.js


// Initialise at bottom of HTML in a <script> tag or within your main js bundle somewhere.

// Set 1
if(document.querySelector('#tabs1')) {
    var myTabs1 = tabs({
      el: '#tabs1',
      tabNavigationLinks: '.tab-link',
      tabContentContainers: '.tab-content'
    });


    // Initialise Set 1
    myTabs1.init();
}




/*=============== ACCORDION ===============*/
const accordionContainers = document.querySelectorAll('.accordion__container')

accordionContainers.forEach((container) => {

    const items = container.querySelectorAll('.accordion__item');

    items.forEach((item) => {

        const accordionHeader = item.querySelector('.accordion__header')
        const accordionContent = item.querySelector('.accordion__content')
        if(item.classList.contains('accordion-open')){
            accordionContent.style.height = accordionContent.scrollHeight + 'px'
        }


        accordionHeader.addEventListener('click', () =>{
            const openItem = container.querySelector('.accordion-open')

            toggleItem(item);

            if(openItem && openItem !== item){
                toggleItem(openItem);
            }
        });

    });

});

window.addEventListener('resize', () => {

    accordionContainers.forEach((container) => {

        const items = container.querySelectorAll('.accordion__item');

        items.forEach((item) => {

            const accordionContent = item.querySelector('.accordion__content')
            if(item.classList.contains('accordion-open')){
                if(accordionContent.scrollHeight > parseInt(accordionContent.style.height)) {
                    accordionContent.style.height = accordionContent.scrollHeight + 'px'
                } else if (item.querySelector('.accordion__description').clientHeight + 15 < parseInt(accordionContent.style.height)) {
                    accordionContent.style.height = (item.querySelector('.accordion__description').clientHeight + 15) + 'px'
                }

            }

        });

    });

});

const toggleItem = (item) => {

    const accordionContent = item.querySelector('.accordion__content')
    if(item.classList.contains('accordion-open')){
        accordionContent.removeAttribute('style')
        item.classList.remove('accordion-open')
    } else {
        accordionContent.style.height = accordionContent.scrollHeight + 'px'
        item.classList.add('accordion-open')
    }
}


function openVideo() {
   var element = document.getElementById("VideoModal");
   element.classList.toggle("active");
}